// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.INSPIRATION {
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
}

.INSPIRATION .div {
  background-color: #ffffff;
  height: 3496px;
  overflow: hidden;
  position: relative;
  width: 1280px;
}

.INSPIRATION .overlap-group {
  height: 18px;
  left: 284px;
  position: absolute;
  top: 1485px;
  width: 137px;
}

.INSPIRATION .rectangle {
  height: 9px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 9px;
  width: 134px;
}

.INSPIRATION .WOMEN-FOUNDERS {
  height: 18px;
  left: 3px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 134px;
}

.INSPIRATION .group {
  height: 200px;
  left: 98px;
  object-fit: cover;
  position: absolute;
  top: 3249px;
  width: 1098px;
}

.INSPIRATION .overlap {
  height: 634px;
  left: -41px;
  position: absolute;
  top: 165px;
  width: 848px;
}

.INSPIRATION .img {
  height: 634px;
  left: 41px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 807px;
}

.INSPIRATION .element {
  height: 634px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 848px;
}

.INSPIRATION .leilani-lopez {
  height: 71px;
  left: 138px;
  object-fit: cover;
  position: absolute;
  top: 872px;
  width: 359px;
}

.INSPIRATION .WOMEN-FOUNDERS-2 {
  height: 10px;
  left: 138px;
  object-fit: cover;
  position: absolute;
  top: 859px;
  width: 99px;
}

.INSPIRATION .championing {
  height: 66px;
  left: 138px;
  object-fit: cover;
  position: absolute;
  top: 968px;
  width: 619px;
}

.INSPIRATION .written-by-heather {
  height: 33px;
  left: 138px;
  object-fit: cover;
  position: absolute;
  top: 1064px;
  width: 429px;
}

.INSPIRATION .overlap-2 {
  height: 135px;
  left: 136px;
  position: absolute;
  top: 1117px;
  width: 574px;
}

.INSPIRATION .leilani-lopez-CEO-of {
  height: 126px;
  left: 2px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 572px;
}

.INSPIRATION .read-more {
  height: 18px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 117px;
  width: 84px;
}

.INSPIRATION .latest-PUBLICATIONS {
  height: 31px;
  left: 898px;
  object-fit: cover;
  position: absolute;
  top: 210px;
  width: 265px;
}

.INSPIRATION .TOPICS-TO-INSPIRE {
  height: 67px;
  left: 230px;
  object-fit: cover;
  position: absolute;
  top: 1317px;
  width: 786px;
}

.INSPIRATION .element-d-a-f {
  height: 477px;
  left: -15px;
  object-fit: cover;
  position: absolute;
  top: 1637px;
  width: 638px;
}

.INSPIRATION .element-c-aa {
  height: 477px;
  left: 641px;
  object-fit: cover;
  position: absolute;
  top: 1637px;
  width: 638px;
}

.INSPIRATION .element-b-ccb-d {
  height: 477px;
  left: -14px;
  object-fit: cover;
  position: absolute;
  top: 2317px;
  width: 638px;
}

.INSPIRATION .element-a-d-c-d {
  height: 477px;
  left: 642px;
  object-fit: cover;
  position: absolute;
  top: 2317px;
  width: 638px;
}

.INSPIRATION .sadie-scheffer {
  height: 58px;
  left: 99px;
  object-fit: cover;
  position: absolute;
  top: 2129px;
  width: 359px;
}

.INSPIRATION .turning-a-gluten {
  height: 24px;
  left: 99px;
  object-fit: cover;
  position: absolute;
  top: 2196px;
  width: 380px;
}

.INSPIRATION .discovering-your {
  height: 117px;
  left: 715px;
  object-fit: cover;
  position: absolute;
  top: 2130px;
  width: 532px;
}

.INSPIRATION .line {
  height: 1px;
  left: 64px;
  object-fit: cover;
  position: absolute;
  top: 1404px;
  width: 1132px;
}

.INSPIRATION .WOMENS-HEALTH {
  height: 18px;
  left: 81px;
  object-fit: cover;
  position: absolute;
  top: 1433px;
  width: 126px;
}

.INSPIRATION .INFANTS-AND-TODDLERS {
  height: 18px;
  left: 247px;
  object-fit: cover;
  position: absolute;
  top: 1433px;
  width: 172px;
}

.INSPIRATION .PARENTING {
  height: 18px;
  left: 459px;
  object-fit: cover;
  position: absolute;
  top: 1433px;
  width: 82px;
}

.INSPIRATION .PRE-TEENS-AND-TEENS {
  height: 18px;
  left: 581px;
  object-fit: cover;
  position: absolute;
  top: 1433px;
  width: 154px;
}

.INSPIRATION .SOCIAL-JUSTICE {
  height: 18px;
  left: 772px;
  object-fit: cover;
  position: absolute;
  top: 1433px;
  width: 108px;
}

.INSPIRATION .SEXUALITY {
  height: 18px;
  left: 919px;
  object-fit: cover;
  position: absolute;
  top: 1433px;
  width: 77px;
}

.INSPIRATION .PREGNANCY-BIRTH {
  height: 18px;
  left: 1036px;
  object-fit: cover;
  position: absolute;
  top: 1433px;
  width: 148px;
}

.INSPIRATION .meet-attorney {
  height: 116px;
  left: 114px;
  object-fit: cover;
  position: absolute;
  top: 2819px;
  width: 440px;
}

.INSPIRATION .of-estate-planning {
  height: 24px;
  left: 114px;
  object-fit: cover;
  position: absolute;
  top: 2942px;
  width: 237px;
}

.INSPIRATION .raana-kashani-gregg {
  height: 59px;
  left: 729px;
  object-fit: cover;
  position: absolute;
  top: 2820px;
  width: 433px;
}

.INSPIRATION .the-innovator-behind {
  height: 48px;
  left: 729px;
  object-fit: cover;
  position: absolute;
  top: 2887px;
  width: 474px;
}

.INSPIRATION .RELATIONSHIPS {
  height: 18px;
  left: 482px;
  object-fit: cover;
  position: absolute;
  top: 1485px;
  width: 110px;
}

.INSPIRATION .GARDENING {
  height: 18px;
  left: 653px;
  object-fit: cover;
  position: absolute;
  top: 1485px;
  width: 88px;
}

.INSPIRATION .HOME-LIFE {
  height: 18px;
  left: 801px;
  object-fit: cover;
  position: absolute;
  top: 1485px;
  width: 74px;
}

.INSPIRATION .TRAVEL {
  height: 18px;
  left: 937px;
  object-fit: cover;
  position: absolute;
  top: 1485px;
  width: 54px;
}

.INSPIRATION .leilani-lopez-2 {
  height: 128px;
  left: 898px;
  object-fit: cover;
  position: absolute;
  top: 299px;
  width: 277px;
}

.INSPIRATION .the-m-list-best-bay {
  height: 64px;
  left: 898px;
  object-fit: cover;
  position: absolute;
  top: 479px;
  width: 277px;
}

.INSPIRATION .clean-and-effective {
  height: 96px;
  left: 898px;
  object-fit: cover;
  position: absolute;
  top: 594px;
  width: 291px;
}

.INSPIRATION .empowering-parents {
  height: 96px;
  left: 898px;
  object-fit: cover;
  position: absolute;
  top: 742px;
  width: 291px;
}

.INSPIRATION .supporting-women-in {
  height: 96px;
  left: 898px;
  object-fit: cover;
  position: absolute;
  top: 889px;
  width: 291px;
}

.INSPIRATION .hormone-free-birth {
  height: 96px;
  left: 898px;
  object-fit: cover;
  position: absolute;
  top: 1069px;
  width: 291px;
}

.INSPIRATION .line-2 {
  height: 1px;
  left: 898px;
  object-fit: cover;
  position: absolute;
  top: 258px;
  width: 277px;
}

.INSPIRATION .WHITE-BUTTON {
  height: 42px;
  left: 581px;
  object-fit: cover;
  position: absolute;
  top: 3063px;
  width: 134px;
}

.INSPIRATION .line-3 {
  height: 1px;
  left: 898px;
  object-fit: cover;
  position: absolute;
  top: 192px;
  width: 277px;
}

.INSPIRATION .group-2 {
  height: 69px;
  left: 31px;
  object-fit: cover;
  position: absolute;
  top: 24px;
  width: 1206px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Inspiration/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf","sourcesContent":[".INSPIRATION {\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n}\n\n.INSPIRATION .div {\n  background-color: #ffffff;\n  height: 3496px;\n  overflow: hidden;\n  position: relative;\n  width: 1280px;\n}\n\n.INSPIRATION .overlap-group {\n  height: 18px;\n  left: 284px;\n  position: absolute;\n  top: 1485px;\n  width: 137px;\n}\n\n.INSPIRATION .rectangle {\n  height: 9px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 9px;\n  width: 134px;\n}\n\n.INSPIRATION .WOMEN-FOUNDERS {\n  height: 18px;\n  left: 3px;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 134px;\n}\n\n.INSPIRATION .group {\n  height: 200px;\n  left: 98px;\n  object-fit: cover;\n  position: absolute;\n  top: 3249px;\n  width: 1098px;\n}\n\n.INSPIRATION .overlap {\n  height: 634px;\n  left: -41px;\n  position: absolute;\n  top: 165px;\n  width: 848px;\n}\n\n.INSPIRATION .img {\n  height: 634px;\n  left: 41px;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 807px;\n}\n\n.INSPIRATION .element {\n  height: 634px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 848px;\n}\n\n.INSPIRATION .leilani-lopez {\n  height: 71px;\n  left: 138px;\n  object-fit: cover;\n  position: absolute;\n  top: 872px;\n  width: 359px;\n}\n\n.INSPIRATION .WOMEN-FOUNDERS-2 {\n  height: 10px;\n  left: 138px;\n  object-fit: cover;\n  position: absolute;\n  top: 859px;\n  width: 99px;\n}\n\n.INSPIRATION .championing {\n  height: 66px;\n  left: 138px;\n  object-fit: cover;\n  position: absolute;\n  top: 968px;\n  width: 619px;\n}\n\n.INSPIRATION .written-by-heather {\n  height: 33px;\n  left: 138px;\n  object-fit: cover;\n  position: absolute;\n  top: 1064px;\n  width: 429px;\n}\n\n.INSPIRATION .overlap-2 {\n  height: 135px;\n  left: 136px;\n  position: absolute;\n  top: 1117px;\n  width: 574px;\n}\n\n.INSPIRATION .leilani-lopez-CEO-of {\n  height: 126px;\n  left: 2px;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  width: 572px;\n}\n\n.INSPIRATION .read-more {\n  height: 18px;\n  left: 0;\n  object-fit: cover;\n  position: absolute;\n  top: 117px;\n  width: 84px;\n}\n\n.INSPIRATION .latest-PUBLICATIONS {\n  height: 31px;\n  left: 898px;\n  object-fit: cover;\n  position: absolute;\n  top: 210px;\n  width: 265px;\n}\n\n.INSPIRATION .TOPICS-TO-INSPIRE {\n  height: 67px;\n  left: 230px;\n  object-fit: cover;\n  position: absolute;\n  top: 1317px;\n  width: 786px;\n}\n\n.INSPIRATION .element-d-a-f {\n  height: 477px;\n  left: -15px;\n  object-fit: cover;\n  position: absolute;\n  top: 1637px;\n  width: 638px;\n}\n\n.INSPIRATION .element-c-aa {\n  height: 477px;\n  left: 641px;\n  object-fit: cover;\n  position: absolute;\n  top: 1637px;\n  width: 638px;\n}\n\n.INSPIRATION .element-b-ccb-d {\n  height: 477px;\n  left: -14px;\n  object-fit: cover;\n  position: absolute;\n  top: 2317px;\n  width: 638px;\n}\n\n.INSPIRATION .element-a-d-c-d {\n  height: 477px;\n  left: 642px;\n  object-fit: cover;\n  position: absolute;\n  top: 2317px;\n  width: 638px;\n}\n\n.INSPIRATION .sadie-scheffer {\n  height: 58px;\n  left: 99px;\n  object-fit: cover;\n  position: absolute;\n  top: 2129px;\n  width: 359px;\n}\n\n.INSPIRATION .turning-a-gluten {\n  height: 24px;\n  left: 99px;\n  object-fit: cover;\n  position: absolute;\n  top: 2196px;\n  width: 380px;\n}\n\n.INSPIRATION .discovering-your {\n  height: 117px;\n  left: 715px;\n  object-fit: cover;\n  position: absolute;\n  top: 2130px;\n  width: 532px;\n}\n\n.INSPIRATION .line {\n  height: 1px;\n  left: 64px;\n  object-fit: cover;\n  position: absolute;\n  top: 1404px;\n  width: 1132px;\n}\n\n.INSPIRATION .WOMENS-HEALTH {\n  height: 18px;\n  left: 81px;\n  object-fit: cover;\n  position: absolute;\n  top: 1433px;\n  width: 126px;\n}\n\n.INSPIRATION .INFANTS-AND-TODDLERS {\n  height: 18px;\n  left: 247px;\n  object-fit: cover;\n  position: absolute;\n  top: 1433px;\n  width: 172px;\n}\n\n.INSPIRATION .PARENTING {\n  height: 18px;\n  left: 459px;\n  object-fit: cover;\n  position: absolute;\n  top: 1433px;\n  width: 82px;\n}\n\n.INSPIRATION .PRE-TEENS-AND-TEENS {\n  height: 18px;\n  left: 581px;\n  object-fit: cover;\n  position: absolute;\n  top: 1433px;\n  width: 154px;\n}\n\n.INSPIRATION .SOCIAL-JUSTICE {\n  height: 18px;\n  left: 772px;\n  object-fit: cover;\n  position: absolute;\n  top: 1433px;\n  width: 108px;\n}\n\n.INSPIRATION .SEXUALITY {\n  height: 18px;\n  left: 919px;\n  object-fit: cover;\n  position: absolute;\n  top: 1433px;\n  width: 77px;\n}\n\n.INSPIRATION .PREGNANCY-BIRTH {\n  height: 18px;\n  left: 1036px;\n  object-fit: cover;\n  position: absolute;\n  top: 1433px;\n  width: 148px;\n}\n\n.INSPIRATION .meet-attorney {\n  height: 116px;\n  left: 114px;\n  object-fit: cover;\n  position: absolute;\n  top: 2819px;\n  width: 440px;\n}\n\n.INSPIRATION .of-estate-planning {\n  height: 24px;\n  left: 114px;\n  object-fit: cover;\n  position: absolute;\n  top: 2942px;\n  width: 237px;\n}\n\n.INSPIRATION .raana-kashani-gregg {\n  height: 59px;\n  left: 729px;\n  object-fit: cover;\n  position: absolute;\n  top: 2820px;\n  width: 433px;\n}\n\n.INSPIRATION .the-innovator-behind {\n  height: 48px;\n  left: 729px;\n  object-fit: cover;\n  position: absolute;\n  top: 2887px;\n  width: 474px;\n}\n\n.INSPIRATION .RELATIONSHIPS {\n  height: 18px;\n  left: 482px;\n  object-fit: cover;\n  position: absolute;\n  top: 1485px;\n  width: 110px;\n}\n\n.INSPIRATION .GARDENING {\n  height: 18px;\n  left: 653px;\n  object-fit: cover;\n  position: absolute;\n  top: 1485px;\n  width: 88px;\n}\n\n.INSPIRATION .HOME-LIFE {\n  height: 18px;\n  left: 801px;\n  object-fit: cover;\n  position: absolute;\n  top: 1485px;\n  width: 74px;\n}\n\n.INSPIRATION .TRAVEL {\n  height: 18px;\n  left: 937px;\n  object-fit: cover;\n  position: absolute;\n  top: 1485px;\n  width: 54px;\n}\n\n.INSPIRATION .leilani-lopez-2 {\n  height: 128px;\n  left: 898px;\n  object-fit: cover;\n  position: absolute;\n  top: 299px;\n  width: 277px;\n}\n\n.INSPIRATION .the-m-list-best-bay {\n  height: 64px;\n  left: 898px;\n  object-fit: cover;\n  position: absolute;\n  top: 479px;\n  width: 277px;\n}\n\n.INSPIRATION .clean-and-effective {\n  height: 96px;\n  left: 898px;\n  object-fit: cover;\n  position: absolute;\n  top: 594px;\n  width: 291px;\n}\n\n.INSPIRATION .empowering-parents {\n  height: 96px;\n  left: 898px;\n  object-fit: cover;\n  position: absolute;\n  top: 742px;\n  width: 291px;\n}\n\n.INSPIRATION .supporting-women-in {\n  height: 96px;\n  left: 898px;\n  object-fit: cover;\n  position: absolute;\n  top: 889px;\n  width: 291px;\n}\n\n.INSPIRATION .hormone-free-birth {\n  height: 96px;\n  left: 898px;\n  object-fit: cover;\n  position: absolute;\n  top: 1069px;\n  width: 291px;\n}\n\n.INSPIRATION .line-2 {\n  height: 1px;\n  left: 898px;\n  object-fit: cover;\n  position: absolute;\n  top: 258px;\n  width: 277px;\n}\n\n.INSPIRATION .WHITE-BUTTON {\n  height: 42px;\n  left: 581px;\n  object-fit: cover;\n  position: absolute;\n  top: 3063px;\n  width: 134px;\n}\n\n.INSPIRATION .line-3 {\n  height: 1px;\n  left: 898px;\n  object-fit: cover;\n  position: absolute;\n  top: 192px;\n  width: 277px;\n}\n\n.INSPIRATION .group-2 {\n  height: 69px;\n  left: 31px;\n  object-fit: cover;\n  position: absolute;\n  top: 24px;\n  width: 1206px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
